import React from 'react'
import { forwardRef, HubStyleObject, As } from '@hub/design-system-base'
import { Text } from '@hub/text'
import { Image } from '@hub/image'
import { Link, LinkBox, LinkOverlay } from '@hub/link'
import { Stack } from '@hub/stack'
import { CloudinaryImage } from '../cloudinary-image'
import { SGPageTemplateContentEntry } from '../../../types/page-templates'

export const InlineDeckItem = forwardRef<
  (SGPageTemplateContentEntry & { displayDate?: string }) & {
    sx?: HubStyleObject
    imageRef?: React.ElementRef<typeof Image>
    as?: As
  },
  typeof LinkBox
>(
  (
    {
      image,
      title,
      shortDescription,
      displayDate,
      callToAction,
      sx,
      imageRef,
      as,
    },
    ref
  ) => (
    <LinkBox ref={ref} sx={sx} as={as}>
      <CloudinaryImage ratio="1" imageSetOrImage={image} imageRef={imageRef} />
      <Stack
        gap="spacing-xs"
        sx={{ paddingTop: 'spacing-sm', paddingRight: 'spacing-sm' }}
      >
        <LinkOverlay href={callToAction.url}>
          <Text tone="strong">{title}</Text>
        </LinkOverlay>
        {shortDescription && <Text noOfLines={2}>{shortDescription}</Text>}
        {displayDate && <Text color="quartz">{displayDate}</Text>}
        {!displayDate && !shortDescription && (
          <Link hasUnderline href={callToAction.url}>
            {callToAction.label}
          </Link>
        )}
      </Stack>
    </LinkBox>
  )
)
